<div class="bl-max-width--tablet-width bl-margin-x--auto">
  <div
    class="bl-block-module bl-font-color--base bl-padding--16 bl-padding-lg--48 bl-margin--24 bl-margin-lg--0 bl-margin-y-lg--48">
    <header class="bl-text-align--center bl-margin-bottom--48">
      <h1 class="bl-text-style--display-3">
        {{ 'userVerificationError/heading' | dictionary }}
      </h1>

      <p class="bl-text-style--default-text-1">
        {{ 'userVerificationError/subheading' | dictionary }}
    </header>
    <ecp-lender-contact-blocks *ngIf="lenderConfig" [lenderData]="lenderConfig"></ecp-lender-contact-blocks>
  </div>
</div>